import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getProjets } from '../services/api';

const NAV_ITEMS = [
  { path: '/dashboard', label: 'Dashboard', icon: 'grid' },
  { path: '/projets', label: 'Projets', icon: 'folder', expandable: true },
  { path: '/contrats', label: 'Contrats API', icon: 'shield' },
];

const ICONS = {
  grid: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
    </svg>
  ),
  users: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  folder: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
  shield: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  terminal: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="4 17 10 11 4 5" /><line x1="12" y1="19" x2="20" y2="19" />
    </svg>
  ),
  chevron: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  dot: (couleur) => (
    <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: couleur, flexShrink: 0 }} />
  ),
  logo: (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="8" fill="url(#grad)" />
      <path d="M8 16l4-4 4 4 4-4 4 4" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 22l4-4 4 4 4-4 4 4" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <defs><linearGradient id="grad" x1="0" y1="0" x2="32" y2="32"><stop stopColor="#6366f1" /><stop offset="1" stopColor="#8b5cf6" /></linearGradient></defs>
    </svg>
  )
};

function getStatutCouleur(statut) {
  if (statut === 'termine') return '#22c55e';
  if (statut === 'en_cours') return '#6366f1';
  return '#64748b';
}

const styles = {
  sidebar: {
    width: 260, height: '100vh', backgroundColor: '#1e293b',
    borderRight: '1px solid #334155', display: 'flex', flexDirection: 'column',
    position: 'fixed', left: 0, top: 0, zIndex: 100,
    transition: 'transform 0.3s ease'
  },
  logoSection: {
    padding: '1.25rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem',
    borderBottom: '1px solid #334155'
  },
  logoText: { fontSize: 18, fontWeight: 800, color: '#f1f5f9', letterSpacing: '0.5px' },
  logoSub: { fontSize: 10, color: '#64748b', fontWeight: 500 },
  nav: { flex: 1, padding: '0.75rem', overflowY: 'auto' },
  navLabel: {
    fontSize: 10, fontWeight: 700, color: '#475569', textTransform: 'uppercase',
    letterSpacing: '1px', padding: '1rem 0.75rem 0.5rem', userSelect: 'none'
  },
  navItem: (active) => ({
    display: 'flex', alignItems: 'center', gap: '0.6rem',
    padding: '0.55rem 0.75rem', borderRadius: 8, cursor: 'pointer',
    textDecoration: 'none', fontSize: 13, fontWeight: active ? 600 : 500,
    color: active ? '#f1f5f9' : '#94a3b8',
    backgroundColor: active ? '#334155' : 'transparent',
    transition: 'all 0.15s ease', marginBottom: 2
  }),
  expandBtn: (open) => ({
    marginLeft: 'auto', transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
    transition: 'transform 0.2s', display: 'flex', opacity: 0.5
  }),
  subList: {
    maxHeight: 300, overflowY: 'auto', marginLeft: '0.5rem',
    borderLeft: '1px solid #334155', paddingLeft: '0.5rem', marginBottom: '0.25rem'
  },
  subItem: (active) => ({
    display: 'flex', alignItems: 'center', gap: '0.5rem',
    padding: '0.4rem 0.6rem', borderRadius: 6, cursor: 'pointer',
    textDecoration: 'none', fontSize: 12, fontWeight: active ? 600 : 400,
    color: active ? '#e2e8f0' : '#64748b',
    backgroundColor: active ? 'rgba(99,102,241,0.15)' : 'transparent',
    transition: 'all 0.15s ease', marginBottom: 1,
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
  }),
  pctBadge: (pct) => ({
    marginLeft: 'auto', fontSize: 10, fontWeight: 700, flexShrink: 0,
    color: pct === 100 ? '#22c55e' : pct > 0 ? '#6366f1' : '#475569'
  }),
  footer: {
    padding: '1rem 1.25rem', borderTop: '1px solid #334155',
    fontSize: 11, color: '#475569', textAlign: 'center'
  }
};

export default function Sidebar({ user }) {
  const location = useLocation();
  const [projets, setProjets] = useState([]);
  const [projetsOpen, setProjetsOpen] = useState(true);

  useEffect(() => {
    if (user) {
      getProjets().then(res => setProjets(res.data.data || [])).catch(() => {});
    }
  }, [user, location.pathname]);

  return (
    <div style={styles.sidebar}>
      <div style={styles.logoSection}>
        {ICONS.logo}
        <div>
          <div style={styles.logoText}>SIGEPRO</div>
          <div style={styles.logoSub}>Pilotage Intelligent</div>
        </div>
      </div>

      <nav style={styles.nav}>
        <div style={styles.navLabel}>Navigation</div>

        <Link to="/dashboard" style={styles.navItem(location.pathname === '/dashboard')}>
          {ICONS.grid}
          <span>Dashboard</span>
        </Link>

        <Link to="/utilisateurs" style={styles.navItem(location.pathname === '/utilisateurs')}>
          {ICONS.users}
          <span>Utilisateurs</span>
        </Link>

        <Link to="/contrats" style={styles.navItem(location.pathname === '/contrats')}>
          {ICONS.shield}
          <span>Contrats API</span>
        </Link>

        <Link to="/sisco" style={styles.navItem(location.pathname === '/sisco')}>
          {ICONS.terminal}
          <span>Sisco</span>
          <span style={{ marginLeft: 'auto', fontSize: 9, fontWeight: 700, padding: '1px 6px', borderRadius: 8, backgroundColor: 'rgba(6,182,212,0.15)', color: '#06b6d4', border: '1px solid rgba(6,182,212,0.3)' }}>AI</span>
        </Link>


        <div
          style={styles.navItem(false)}
          onClick={() => setProjetsOpen(!projetsOpen)}
        >
          {ICONS.folder}
          <span>Projets</span>
          <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6366f1', fontWeight: 700 }}>
            {projets.length}
          </span>
          <span style={styles.expandBtn(projetsOpen)}>{ICONS.chevron}</span>
        </div>

        {projetsOpen && projets.length > 0 && (
          <div style={styles.subList}>
            {projets.map(p => (
              <Link
                key={p._id}
                to={`/projet/${p._id}`}
                style={styles.subItem(location.pathname === `/projet/${p._id}`)}
              >
                {ICONS.dot(getStatutCouleur(p.statut))}
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.titre}</span>
                <span style={styles.pctBadge(p.avancement_global)}>
                  {p.avancement_global}%
                </span>
              </Link>
            ))}
          </div>
        )}
      </nav>

      <div style={styles.footer}>
        {user ? `${user.nom} — ${user.role.replace('_', ' ')}` : 'Non connecte'}
      </div>
    </div>
  );
}
